import React, { useState } from "react";
import InputField from "../../common_component/component/InputField";
import CuButton from "../../all-patient/components/CuButton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getImageURL } from "../../_helper/utils/image";
import { useUploadfile } from "../../_helper/actions/mutation/image";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { ImFolderUpload } from "react-icons/im";
import DateAge from "../../new_appointment/_helper/utils.js/DateAge";
import CuInput from "../../all-patient/components/CuInput";
import PasswordInput from "../../components/authentication/view/PasswordInput";
import Confirmation from "../../common_component/component/Confirmation";
import CuModal from "../../common_component/component/CuModal";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import CuSuggestionBox from "../../common_component/component/CuSuggestionBox";

const DetailsInput = ({
  save,
  roles,
  // setRole,
  onChange,
  readOnly,
  mode,
  userDetails,
  setFormData,
  formData,
  // handleUserInputChange,
  fileInputRef,
  imagePreview,
  setImagePreview,
  isLoading,
  isCheckboxChecked,
  setIsCheckboxChecked,
}) => {
  const uploadFileMutation = useUploadfile();
  const handleInputChange = (e, name) => {
    onChange(e, name);
  };

  const [selectedFile, setSelectedFile] = useState();
  const [onCheck, setOnCheck] = useState(false);
  const [clinic] = useAtom(clinicAtom);
  const [searchInput, setSearchInput] = useState({
    phone_number: "",
  });

  const handleCheckboxClick = (e) => {
    if (e.target.checked) {
      setOnCheck(true);
    } else {
      setIsCheckboxChecked(false); // Uncheck the checkbox immediately
    }
  };

  const handleModalConfirmation = () => {
    setIsCheckboxChecked(true);
    setOnCheck(false);
  };

  const handleCancel = () => {
    setOnCheck(false);
    setIsCheckboxChecked(false);
  };

  const handleUserInputChange2 = (e, field) => {
    let value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    if (value === true) {
      value = "True";
    } else if (value === false) {
      value = "False";
    }

    if (field === "phone_number" && value?.length > 10) {
      return;
    }

    // is_accepted_appointment

    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    // if (field === "first_name" || field === "last_name") {
    //   setFormData({
    //     ...formData,
    //     [field]: value,
    //   });
    // } else {
    //   setFormData({
    //     ...formData,
    //     [field]: value,
    //   });
    // }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    save(formData);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    // setFormData({
    //   ...formData,
    //   profile_image: file,
    // });

    setSelectedFile(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleFileUpload = async () => {
    if (!selectedFile) return;

    const formdata = new FormData();

    formdata.append("files", selectedFile);

    formdata.append("upload_to", "staff");

    formdata.append("staff_id", formData?.id);

    uploadFileMutation.mutate(formdata, {
      onSuccess: (data) => {
        toast.success("File uploaded successfully");
        let res = getImageURL(data[0]?.url);
        setFormData({
          ...formData,
          profile_img: res,
        });
      },

      onError: (err) => {
        toast.error("Error uploading file");
      },
    });
  };

  const handleFileButtonClick = () => {
    fileInputRef.current.click();
  };

  const navigate = useNavigate();

  const { data: phoneNumberOptions } = useItemsFilter(
    ApiEndPoint.CLINIC,
    `?backend=True&action=getClinicStaff&clinic_id=${clinic?.id}&mobile=${searchInput.phone_number}`,
    searchInput.phone_number.length > 0 && clinic ? true : false
  );

  const handlePhoneNumberChange = (val) => {
    setFormData((prev) => ({ ...prev, phone_number: val }));
  };

  const handlePhoneNumberSearch = (val) => {
    setSearchInput((prev) => ({ ...prev, phone_number: val }));
  };

  const handlePhoneNumberSelect = (val) => {
    //("val-------", val);
    setFormData({
      phone_number: val.phone_number,
      first_name: val.first_name,
      last_name: val.last_name,
      email: val.email,
      employee_number: val.employee_number,
      department: val.department,
      status: val.status ? "True" : "False", // Assuming status is a boolean
      // profile_img: val.profile_img || "", // Assuming val.profile_img might be undefined
    });
    setSearchInput({ phone_number: "" });
  };

  //("formData----------", formData);

  return (
    <div className="pr-4">
      {userDetails ? (
        <>
          <form onSubmit={handleSubmit} className="flex flex-col gap-3">
            <CuInput
              label={"Last login"}
              onChange={(e) => handleUserInputChange2(e, "login")}
              value={formData?.istLastLogin}
              disabled
            />
            <div className="flex-1">
              <CuSuggestionBox
                label={`Phone Number`}
                value={formData.phone_number}
                onChange={handlePhoneNumberChange}
                disabled={mode === "view"}
                searchable={true}
                setSearchInput={handlePhoneNumberSearch}
                options={phoneNumberOptions?.map(
                  (item) => item.doctor_personal_details
                )}
                searchInput={searchInput.phone_number}
                renderKey="phone_number"
                handleSelectOption={handlePhoneNumberSelect}
                add={true}
              />
            </div>
            <div className="flex items-center gap-3">
              <div className="flex-1">
                <CuInput
                  label={"First Name"}
                  onChange={(e) => handleUserInputChange2(e, "first_name")}
                  value={formData?.first_name}
                  type={"text"}
                  required={true}
                  disabled={readOnly}
                />
              </div>
              <div className="flex-1">
                <CuInput
                  label={"Last Name"}
                  onChange={(e) => handleUserInputChange2(e, "last_name")}
                  value={formData?.last_name}
                  type={"text"}
                  required={true}
                  disabled={readOnly}
                />
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex-1">
                <CuInput
                  label={"Email"}
                  onChange={(e) => handleUserInputChange2(e, "email")}
                  value={formData?.email}
                  type={"email"}
                  required={true}
                  disabled={readOnly}
                />
              </div>
            </div>
            <div className="w-full">
              <PasswordInput
                placeholder={"Enter Password"}
                onChange={(e) => handleUserInputChange2(e, "password")}
                value={formData?.password}
                custom={true}
                label={"Password"}
              />
            </div>
            <div className="w-full">
              <PasswordInput
                placeholder={"Enter Confirm Password"}
                onChange={(e) => handleUserInputChange2(e, "confirm_password")}
                value={formData?.confirm_password}
                custom={true}
                label={"Confirm Password"}
              />
            </div>
            <div>
              <label className="text-base">Profile Image</label>
              <div className="border-2 p-1 rounded mt-2 gap-6 h-[100px] w-full flex justify-center items-center border-dashed">
                {imagePreview ? (
                  <>
                    <img
                      src={imagePreview}
                      alt="Preview"
                      className="h-11 w-28"
                    />

                    <CuButton
                      onClick={() => {
                        setFormData({
                          ...formData,
                          profile_img: "",
                        });
                        setImagePreview("");
                      }}
                      className="text-[#FF8484]"
                      disabled={readOnly}
                      type="button"
                    >
                      Remove
                    </CuButton>
                  </>
                ) : (
                  <ImFolderUpload />
                )}

                {imagePreview && !formData?.profile_img ? (
                  <CuButton
                    onClick={() => handleFileUpload()}
                    className="bg-[#EBF8EC] rounded w-[123px] h-11 text-sm"
                    isLoading={uploadFileMutation?.isLoading}
                    type="button"
                  >
                    Upload
                  </CuButton>
                ) : !formData?.profile_img ? (
                  <button
                    onClick={() => handleFileButtonClick()}
                    className="bg-[#EBF8EC] rounded w-[123px] h-11 text-sm"
                    type="button"
                  >
                    Browse
                  </button>
                ) : (
                  ""
                )}

                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  disabled={readOnly}
                  // capture="environment"
                  style={{ display: "none" }}
                  onChange={handleFileSelect}
                />
              </div>

              <div className="grid grid-cols-2 gap-2 mt-2">
                <InputField
                  label={"Employee Number"}
                  onChange={(e) => handleUserInputChange2(e, "employee_number")}
                  value={formData?.employee_number}
                  type={"number"}
                  disabled={readOnly}
                />

                <InputField
                  label={"Department"}
                  onChange={(e) => handleUserInputChange2(e, "department")}
                  value={formData?.department}
                  disabled={readOnly}
                />
              </div>
              <div className="flex py-4">
                <div>
                  <h3>User Status</h3>
                </div>

                <div className="flex gap-4 ml-auto">
                  <div className="inline-flex items-center">
                    <label
                      className="relative flex items-center p-1.5 rounded-full cursor-pointer"
                      htmlFor="check1"
                    >
                      <input
                        type="checkbox"
                        className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-[#C7EAC9] checked:bg-[#C7EAC9] checked:before:bg-[#C7EAC9] hover:before:opacity-10"
                        id="check1"
                        disabled={readOnly}
                        checked={formData?.status == "True"}
                        onChange={(e) => handleUserInputChange2(e, "status")}
                      />
                      <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-3.5 w-3.5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-width="1"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      </span>
                    </label>
                    <label>Active</label>
                  </div>
                </div>
              </div>
              <div className="flex gap-3 m-4">
                <CuButton
                  className="border rounded w-full lg:h-10 xl:h-11"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </CuButton>
                <CuButton
                  type="submit"
                  disabled={readOnly}
                  className="bg-[#EBF8EC] w-full lg:h-10 xl:h-11"
                  isLoading={isLoading}
                >
                  {mode === "edit"
                    ? "Edit"
                    : mode === "create"
                      ? "Create"
                      : "Save"}
                </CuButton>
              </div>
            </div>
          </form>
        </>
      ) : (
        <>
          <InputField
            onChange={(e) => handleInputChange(e, "name")}
            label="Name"
            value={roles?.name}
            disabled={readOnly}
          />
          <div className="py-2">
            <label>Description</label>
            <textarea
              value={roles?.description}
              onChange={(e) => handleInputChange(e, "description")}
              className="w-full min-h-24 border p-1"
              disabled={readOnly}
            />
          </div>
          <div className="flex items-center gap-4 my-2 mb-4">
            <input
              type="checkbox"
              checked={isCheckboxChecked}
              onChange={handleCheckboxClick}
              className="cursor-pointer"
            />
            <span>Is Accept Appointment</span>
          </div>
          <div className="flex gap-3 flex-col">
            <CuButton
              className="border rounded w-full lg:h-10 xl:h-11"
              onClick={() => navigate(-1)}
            >
              Cancel
            </CuButton>
            <CuButton
              onClick={save}
              disabled={readOnly}
              className="bg-[#EBF8EC] w-full lg:h-10 xl:h-11"
            >
              {mode === "edit" ? "Edit" : "Create"}
            </CuButton>
          </div>
          {onCheck && (
            <CuModal closeModal={handleCancel}>
              <Confirmation
                heading="Is Appointment Accept"
                confirmationText="This role will be visible on the patient portal are you sure ?"
                submitBtnText="Yes"
                onCancel={handleCancel}
                onClick={handleModalConfirmation}
              />
            </CuModal>
          )}
        </>
      )}
    </div>
  );
};

export default DetailsInput;
